import RelatorioAgenda from './RelatorioAgenda';

export default RelatorioAgenda;